
<template>
  <div>
    <TopBar :pagetitle="title" :back-url="backurl" />
    <div class="rect">
      <div class="about">
        请认真准确回答用户的问题
        <div class="commentRect">
          <textarea v-model="commentBody" class="commentBody" rows="15" :maxlength="maxFont" />
          <div class="commnetFontNum">还可以输入{{ maxFont-nowFont }}字</div>
        </div>
      </div>
      <van-button type="info" size="large" :loading="buttonLoading" :color="GetColorMain()" @click="OnAddQuestion">提交回复</van-button>
    </div>

  </div>
</template>
<script>
import request from '@/utils/request'
import { Button } from 'vant'
import TopBar from '@/components/TopBar'
import { MyNotify, getUrlKey } from '@/utils/base'
import { GetColorMainBack, GetColorMain, GetColorSecondary, GetSysTitle, GetColorMainLine } from '@/utils/base'
export default {
  components: {
    [Button.name]: Button,
    TopBar
  },
  data() {
    return {
      title: '商品咨询回复',
      backurl: '/my/index',
      maxFont: 2048,
      nowFont: 0,
      commentBody: '',
      buttonLoading: false,
      qaId: undefined,
      commodityId: undefined
    }
  },
  watch: {
    commentBody(newValue, oldValue) {
      this.nowFont = newValue.length
      // this.formData.body = newValue
    }
  },
  created() {
    // commodity
    this.qaId = this.$route.params.id
    this.commodityId = getUrlKey('commodity')
  },
  methods: {
    GetColorMainLine,
    GetColorMainBack,
    GetColorMain,
    GetColorSecondary,
    GetSysTitle,
    OnAddQuestion() {
      if (!this.commentBody || this.nowFont < 10) {
        MyNotify('error', '请至少填写10个字的咨询回复!')
        return
      }
      this.buttonLoading = true
      request({
        url: '/Store/addShopCommodityQAAnswer',
        method: 'post',
        data: {
          qaId: this.qaId,
          body: this.commentBody,
          commodityId: this.commodityId
        }
      }).then(response => {
        this.buttonLoading = false
        if (!response.success) {
          return
        }
        MyNotify('success', '提交成功!')
        this.$router.go(-1)
      })
    }
  }
}
</script>
<style scoped>
.rect{
    margin: 1em;
    border-radius: 0.5em;
    overflow: hidden;
    background-color: #fff;
    border-bottom: 1px solid #dadada;
}
.rect .about{
  padding: 1em;
}
.rect .score{
    margin-top: 0.6em;
}
.rect .commentRect{
    margin-top: 1em;
    border: 1px solid #cacaca;
    padding: 0.5em;
}
.rect .commentBody{
    width: 99%;
    resize: none;
    border: none;
}
.rect .commnetFontNum{
    text-align: right;
    font-size: 0.7em;
    color: #999;
}
.EmptyRect{
  height: 3em;
}
.downButton{
  position: fixed;
  left: 0;
  bottom: 0;
  width: 100%;
  z-index: 2;
}
.downButton button{
  width: 100%;
}
</style>

